import React, {useEffect, useState} from "react"
import StoreList from './StoreList';
import { translate } from '../Services/translation';
import Popup from './Popup';
import { getClickCollectOrgs } from '../Actions/GetClickCollectOrgs.action';
import { useDispatch, useSelector } from 'react-redux';

const ClickCollectContainer = ({productId, isInStock}) => {
  const dispatch = useDispatch();
  const [isOpenStoreList, setOpenStoreList] = useState(false);
  const stores = useSelector((state) => state.clickCollectOrgs);
  const hasStock = (isInStock === "True")
  const [store, setStore] = useState(null);
  const [reRender, setReRender] = useState(true);

  const handleOpenPopup = (productId) => {
    setOpenStoreList(true);
    dispatch(getClickCollectOrgs(productId))
  }

  useEffect(() => {
    let preffStore = JSON.parse(window.localStorage.getItem("preferedaddress"));
    let clickStore = JSON.parse(window.localStorage.getItem("preferredclickcollectaddress"));
    
    if(store == null && preffStore && preffStore.productAssortment?.includes("active")&& reRender){

        let streetAddress = preffStore.streetName;
        streetAddress += preffStore.zipCode ? " " + preffStore.zipCode : "";
        streetAddress += preffStore.city ? " " + preffStore.city : "";
  
        setStore({
          organizationId: preffStore.organizationId,
          organizationName: preffStore.companyName,
          email: preffStore.email,
          homePage: preffStore.homePage,
          address: streetAddress,
          productAssortment: preffStore.productAssortment,
          shopName: preffStore.name,
          longitude: preffStore.longitude,
          latitude: preffStore.latitude
        })
        setReRender(false)
        window.localStorage.removeItem('preferredclickcollectaddress');
      
    }
    else if(clickStore){
      setStore(clickStore);
    }

  },[isOpenStoreList])

  const getStockIndicator = (stock) => {
    if (stock == 0) {
      return "dot--red";
    } else if (stock == 1) {
      return "triangle";
    } else {
      return "dot";
    }
  };

  return (
  <div className="easyline-stock-info">
    {hasStock ? (
      <div className="product-detail__reseller-container">
        <div className="top-row">
          <p>{translate('product.availability')}</p>

          {store && store.organizationId && (
            <a
              tabIndex={0}
              onClick={() => handleOpenPopup(productId)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleOpenPopup(productId)
                }
              }}
            >
              {translate('product.changereseller')}
            </a>
          )}
        </div>
        <div className="info-row">
          <div className="text-container">
            <p className="title">
              {translate('product.clickandcollect')}
            </p>
            {store && store.organizationId ? (
              <p className="stock-info">  
                <div className={getStockIndicator(store.stock)}></div>               
                <span className="">
                  {store.stock > 0
                    ? `+${store.stock} ${translate('storelist.isinstock')}`
                    : `${store.stock} ${translate('storelist.isinstock')}`}
                </span>
                <a
                  tabIndex={0}
                  onClick={() => handleOpenPopup(productId)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      handleOpenPopup(productId)
                    }
                  }}
                >
                  {store.shopName}
                </a>
              </p>
            ) : (
              <p className="stock-info select-reseller">
                <span className="dot--not-selected"></span>
                <a
                  tabIndex={0}
                  onClick={() => handleOpenPopup(productId)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      handleOpenPopup(productId)
                    }
                  }}
                >
                  {translate('product.selectreseller')}
                </a>
              </p>
            )}
          </div>
        </div>
      </div>
    ) : (
      <div className="product__stock-info contact-store">
        {translate('product.isnotinstock')}
      </div>
    )}
    <Popup
      isOpen={isOpenStoreList}
      setOpen={setOpenStoreList}
      component={
        <StoreList
          store={store}
          setStore={setStore}
          stores={stores.organizations}
          closeModal={() => setOpenStoreList(false)}
        />
      }
    />
  </div>
)
}

export default ClickCollectContainer
